import { render, staticRenderFns } from "./DropdownFilter.vue?vue&type=template&id=55ff27de&scoped=true&"
import script from "./DropdownFilter.vue?vue&type=script&lang=js&"
export * from "./DropdownFilter.vue?vue&type=script&lang=js&"
import style0 from "./DropdownFilter.vue?vue&type=style&index=0&id=55ff27de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ff27de",
  null
  
)

export default component.exports